export default {
    install(Vue) {
        Vue.prototype.$toast = function (message, duration = 2000) {
            const toastEl = document.createElement('div')
            toastEl.className = 'mini-toast'
            toastEl.textContent = message
            document.body.appendChild(toastEl)

            setTimeout(() => {
                toastEl.classList.add('fade-out')
                setTimeout(() => toastEl.remove(), 300)
            }, duration)
        }
    }
}
